import React from 'react';

const OpenPopupEntityAppContext = React.createContext<{
  openEntityPopup: ({
    app,
    entity,
    entityValue,
    initialTabId,
    selectedBonusPeriodId,
    onEntityAppClosed,
  }: {
    app: EntityDetails.App;
    entity: EntityDetails.Entity;
    entityValue: string;
    initialTabId?: string;
    selectedBonusPeriodId?: string;
    overrideMode?: boolean;
    onEntityAppClosed?: () => void;
  }) => void;
  isEntityPopupOpen: boolean;
}>({
  openEntityPopup: () => {
    console.error('openEntityPopup is not defined');
  },
  isEntityPopupOpen: false,
});

export default OpenPopupEntityAppContext;
